import React from 'react'
import { Box, Container } from '@mui/material'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import { TESTIMONIAL_VARIANTS } from '../Sections.const'

const Testimonials = ({ variant = TESTIMONIAL_VARIANTS.DEFAULT, Element }) => {
	const metaData = useSectionMetaData()

	return (
		<Box className={clsx(variant, 'section-testimonial')}>
			<Container className="section-testimonial-content">{Element && <Element metaData={metaData} />}</Container>
		</Box>
	)
}

Testimonials.propTypes = {
	variant: PropTypes.oneOf(Object.values(TESTIMONIAL_VARIANTS)),
	Element: PropTypes.elementType,
}

export default Testimonials
